import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';
import { useSelector } from 'react-redux';

import { baseTheme } from '../../theme';
import AdminWelcomePage from './welcome-page';
import ListPostsPage from './list-posts-page';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(0),
      paddingRight: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(0),
    },
  }),
);

export default function AdminIndexPage() {
  const classes = useStyles(baseTheme);
  const newUser = useSelector((state: any) => state.auth.newUser);
  // const newUser = true; // use to test Welcome page for development

  return (
    <Grid item container direction="column" className={classes.root}>
      { newUser ? <AdminWelcomePage /> : <ListPostsPage />}
    </Grid>
  );
}
